import { graphql } from 'gql';

export const uerAddUerToWorkOrderObjectsGql = graphql(`
    mutation uerAddUersToWorkOrderObjects(
        $workOrderId: Long!
        $workOrderObjectIds: [Long!]!
        $uerInputs: [PriceListUerRowInput!]!
        $constructionTypeId: Int!
        $chapter: ChapterEnum!
    ) {
        uerAddUersToWorkOrderObjects(
            workOrderId: $workOrderId
            workOrderObjectIds: $workOrderObjectIds
            uerInputs: $uerInputs
            constructionTypeId: $constructionTypeId
            chapter: $chapter
        ) {
            data
            result
            message
            validation {
                message
            }
            buttonText
            hasValidation
            hideValidation
        }
    }
`);

export const uerWorkOrderUerSelectionList = graphql(`
    query uerWorkOrderUersSelectionListAsync(
        $skip: Int
        $take: Int
        $workOrderId: Long!
        $constructionTypeId: Int!
        $workOrderObjectIds: [Long!]!
        $chapter: ChapterEnum
        $where: WorkOrderUerItemDataFilterInput
    ) {
        uerWorkOrderUersSelectionListAsync(
            skip: $skip
            take: $take
            workOrderId: $workOrderId
            constructionTypeId: $constructionTypeId
            workOrderObjectIds: $workOrderObjectIds
            chapter: $chapter
            where: $where
        ) {
            items {
                id
                sectionId
                sectionName
                groupId
                groupName
                groupFullName
                code
                unit
                name
                unitCost
                chapter
                status
                status
                justification
            }
            totalCount
        }
    }
`);
